import React from "react";

const BolgView = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    blog,
  } = props;
  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      {console.log("blog", blog)}
      <div className="w-full flex flex-col pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Title
        </label>
        <sapn className="font-normal text-xs">{blog.title}</sapn>
      </div>

      <div className="w-full flex flex-col mt-2 pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white font-semibold">
          Description
        </label>
        <p className="font-normal text-xs max-h-[800px] overflow-auto">{blog.description}</p>
      </div>

      <div className="flex flex-col mt-2 pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Image
        </label>
        <div className="md:pl-3">
          <img src={blog.image} alt="Preview" className="w-32 h-32 mt-2" />
        </div>
      </div>

      <div className="w-full flex flex-col mt-2 pl-5">
        <span className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Active Status
        </span>
        <span className="font-normal text-xs">
          {blog.status ? "Active" : "Inactive"}
        </span>
      </div>
    </div>
  );
};

export default BolgView;
